import { TollDomainState, INavigation, IDomainsActions } from './types';

const getters = {
  getTollDomains(state: TollDomainState) {
    return state.domains;
  },
  getTollDomainInfo(state: TollDomainState) {
    return state.domainInfo;
  },
  getTollDomainsState(state: TollDomainState) {
    return state.tollDomainsState;
  },
  getNavigationConfiguration(state: TollDomainState): INavigation {
    return state.navigation;
  },
  getTotal(state: TollDomainState): number {
    return state.total;
  },
  getErrorMessage(state: TollDomainState): string {
    return state.errorMessage;
  },
  getIsLastDomainPage(state: TollDomainState): boolean {
    return state.navigation.isLastDomainPage;
  },
  getUserSelectionDomains(state: TollDomainState): string[] {
    return state.userSelection.domains;
  },
  getUserSelectionDomainsIds(state: TollDomainState): number[] {
    return state.userSelection.domains.map(id => Number(id));
  },
  getNumberUserSelectionDomains(state: TollDomainState): number {
    return state.userSelection.domains.length;
  },
  getUserSelectionDomainsActionsNames(state: TollDomainState): string[] {
    return Object.values(state.userSelection.actions).map(x => x.label);
  },
  getUserSelectionDomainsActions(state: TollDomainState): { [key: string]: IDomainsActions } {
    return state.userSelection.actions;
  },
  getRule(state: TollDomainState) {
    return state.rule;
  },
  getDatInstances(state: TollDomainState) {
    return state.datInstances;
  },
  getVariants(state: TollDomainState) {
    return state.variants;
  },
  getVariantById: (state: TollDomainState) => (variantId: number) => state.variants.find(v => v.id === variantId)
};
export default getters;
